import { Button, Menu, MenuItem, Typography } from "@mui/material";
import { useI18n } from "../hooks/useI18n";
import { useState } from "react";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useQueries } from "../hooks/useQueries";
import { HealthRecord } from "@syadem/kairos-citizen-js";

export function DownloadCertificateButton({ healthRecord }: { healthRecord: HealthRecord }) {
  const { t } = useI18n();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { getVaccinationCertificate } = useQueries();

  const handleDownloadPdf = async ({ extended }: { extended: boolean }) => {
    const blob = await getVaccinationCertificate.call({
      healthRecordId: healthRecord.id,
      extended: extended
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${healthRecord.lastName} ${healthRecord.firstNames}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }
  
  return (
    <>
      <Button
        variant="outlined"
        startIcon={<SaveAltIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {t("patients.certificate")}
      </Button>
      <Menu open={open} onClose={() => setAnchorEl(null)} anchorEl={anchorEl}>
        <MenuItem
          onClick={() => {
            handleDownloadPdf({ extended: false });
          }}
          sx={{ bgColor: "transparent" }}
        >
          <Typography fontSize="0.9rem">{t("patients.vaccinationHistory")}</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDownloadPdf({ extended: true });
          }}
          sx={{ color: "inherit" }}
        >
          <Typography fontSize="0.9rem">{t("patients.vaccinationHistoryAndStatus")}</Typography>
        </MenuItem>
      </Menu>
    </>
  )
}
